import React from 'react'
import Link from 'gatsby-link'
import DownArrows from '../components/DownArrows'
import Feature from '../parts/home/Feature'
import About from '../parts/home/About'
import Services from '../parts/home/Services'
import Projects from '../parts/home/Projects'
import Experience from '../parts/home/Experience'
import Contact from '../parts/home/Contact'


export default ({ data }) => {
  return (
    <div>
      <Feature />
      <About />
      <DownArrows />
      <Services />
      <Projects />
      <DownArrows />
      <Experience />
      <Contact />
    </div>
  )
};

export const query = graphql`
  query BobQuery {
    allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js